



































































































































import {Vue, Component, PropSync, Watch} from 'vue-property-decorator';
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import {SelectWings} from "wings-ui-components";
import {XiaomiType} from "@/store/push/application/types";
import { InputWings } from "wings-ui-components";

@Component({components: {SelectWings, proxySettingsForm, InputWings}})
export default class XiaomiSettings extends Vue {
  @PropSync('xiaomiOptions') xiaomi!: XiaomiType;

  private serverTypeList: string[] = ['PRODUCTION', 'SIMULATOR']
  private isProxySettings: boolean = false;

  created() {
    if(this.xiaomi.proxy_settings_name) this.isProxySettings = true;
  }

  @Watch('isProxySettings')
  onChangeProxy(newValue: boolean) {
    if (!newValue) this.xiaomi.proxy_settings_id = undefined;
  }
}
